module.exports = __webpack_public_path__ + "img/noMode.4db44ed8.png";